/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import {
  Input,
  InputFormat,
  MalhaSelect,
  GerenciaSelect,
  PoloSelect,
  SubestacaoSelect,
  AlimentadorSelect,
  DatePicker,
  DefaultSelect,
  SimNaoSelect,
  UsuarioSelect,
  TrueFalseSelect,
} from '../../../components';
import * as Roles from '../../../constants/role';
import * as Status from '../../../constants/status';
import { isFalse, isInspecaoMtBt, isNullOrUndefined, isTrue } from 'utils';

const useStyles = makeStyles(theme => ({
  gridContainer: {
    padding: theme.spacing(2),
    paddingTop: 20,
    paddingBottom: 30
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  }
}));

const InformacaoBasicaForm = ({
  values,
  setValues,
  handleChange,
  errors,
  isAdmin,
  usuarioCroquiPodeEditar,
  podeEditarAuditoria,
  patchNsirAuditoria
}) => {
  const classes = useStyles();

  return (
    <>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          label="NSIR"
          name="codigo"
          onChange={handleChange}
          value={values.codigo}
          disabled={!isAdmin}
          isRequired
          error={errors && errors.codigo ? true : false}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          error={errors && errors.equipamento ? true : false}
          isRequired
          label="Equipamento"
          name="equipamento"
          onChange={handleChange}
          value={values.equipamento}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <DatePicker
          label="Data Vencimento"
          onChange={data =>
            setValues({
              ...values,
              vencimento: data.valueOf()
            })
          }
          value={values.vencimento}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <DefaultSelect
          error={errors && errors.area ? true : false}
          isRequired
          label="Área"
          name="area"
          showEmpty
          options={[
            { id: 'MISTA', nome: 'Mista' },
            { id: 'RDR', nome: 'Rural' },
            { id: 'RDU', nome: 'Urbana' }
          ]}
          onSelect={handleChange}
          value={values.area}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <SimNaoSelect
          error={errors && errors.prioridade ? true : false}
          label="Prioridade"
          name="prioridade"
          onChange={handleChange}
          value={values.prioridade}
          disabled={!isAdmin}
          isRequired
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <SimNaoSelect
          error={errors && errors.anomalia ? true : false}
          label="Anomalia"
          name="anomalia"
          onChange={handleChange}
          value={values.anomalia}
          disabled={!isAdmin}
          isRequired
        />
      </Grid>
      {isInspecaoMtBt(values.tipoServicoId) && <>
        <Grid item md={2} xs={6}>
          <TrueFalseSelect
            label="Adere"
            disabled={!isAdmin}
            isRequired
            error={errors && errors.possuiAdere ? true : false}
            onChange={event => {
              var value = event.target.value;
              if (value === 'false' || isNullOrUndefined(value)) {
                setValues({ ...values, possuiAdere: value, adereMonth: '' });
              } else {
                setValues({ ...values, possuiAdere: value });
              }
            }}
            value={values.possuiAdere}
          />
        </Grid>
        <Grid item md={2} xs={6}>
          <InputFormat
            error={isTrue(values.possuiAdere) && errors && errors.adereMonth ? true : false}
            name="adereMonth"
            label="Adere Mês/Ano"
            value={values.adereMonth}
            onChange={handleChange}
            disabled={!isAdmin || isFalse(values.possuiAdere)}
            format="##/####"
          />
        </Grid>
      </>}
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <UsuarioSelect
          label="Inspetor"
          onSelect={inspetorId => setValues({
            ...values,
            inspetorId
          })}
          ativo
          showMatriculaCemig
          grupos={[Roles.ADMIN, Roles.INSPETOR]}
          value={values.inspetorId}
          disabled={values.status !== Status.EM_CRIACAO || (!isAdmin && !usuarioCroquiPodeEditar)}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <UsuarioSelect
          label="Observador/Ajudante"
          value={values.inspetorAuxiliarId}
          disabled
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <UsuarioSelect
          label="Digitador"
          onSelect={digitadorId => setValues({
            ...values,
            digitadorId
          })}
          ativo
          grupos={[Roles.ADMIN, Roles.DIGITADOR]}
          value={values.digitadorId}
          disabled={[Status.AGUARDANDO_DIGITACAO, Status.EM_DIGITACAO, Status.DIGITACAO_FINALIZADA, Status.EXECUTADA_GDIS].includes(values.status) || !isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          label="Data Inspeção"
          value={values.dataFinalInspecaoValue}
          disabled
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          label="Data Digitação"
          value={values.dataFinalDigitacaoValue}
          disabled
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          label="Data Executada GDIS"
          value={values.dataConclusaoValue}
          disabled
        />
      </Grid>
      <Grid item xs={3} sm={2} className={classes.fieldContainer}>
        <Input
          label="CT Plan"
          name="ctPlan"
          onChange={handleChange}
          value={values.ctPlan}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={3} sm={2} className={classes.fieldContainer}>
        <Input
          label="CT Exec"
          name="ctExec"
          onChange={handleChange}
          value={values.ctExec}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <MalhaSelect
          error={errors && errors.malhaId ? true : false}
          isRequired
          onSelect={value =>
            setValues({
              ...values,
              malhaId: value,
              gerenciaId: null,
              poloId: null,
              subestacaoId: null,
              alimentadorId: null
            })
          }
          value={values.malhaId}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={isInspecaoMtBt(values.tipoServicoId) ? 2 : 3}>
        <GerenciaSelect
          onSelect={value =>
            setValues({
              ...values,
              gerenciaId: value,
              poloId: null,
              subestacaoId: null,
              alimentadorId: null
            })
          }
          value={values.gerenciaId}
          malhaId={values.malhaId}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={isInspecaoMtBt(values.tipoServicoId) ? 2 : 3}>
        <PoloSelect
          onSelect={value =>
            setValues({
              ...values,
              poloId: value,
              subestacaoId: null,
              alimentadorId: null
            })
          }
          value={values.poloId}
          malhaId={values.malhaId}
          gerenciaId={values.gerenciaId}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={2}>
        <SubestacaoSelect
          onSelect={value =>
            setValues({
              ...values,
              subestacaoId: value,
              alimentadorId: null
            })
          }
          value={values.subestacaoId}
          malhaId={values.malhaId}
          gerenciaId={values.gerenciaId}
          poloId={values.poloId}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={2}>
        <AlimentadorSelect
          onSelect={value =>
            setValues({
              ...values,
              alimentadorId: value
            })
          }
          value={values.alimentadorId}
          malhaId={values.malhaId}
          gerenciaId={values.gerenciaId}
          poloId={values.poloId}
          subestacaoId={values.subestacaoId}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <InputFormat
          error={errors && errors.latitude ? true : false}
          helperText={errors && errors.latitude ? 'O campo é inválido' : ''}
          name="latitude"
          label="Latitude"
          value={values.latitude}
          onChange={handleChange}
          disabled={!isAdmin}
          format="##,######"
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <InputFormat
          error={errors && errors.longitude ? true : false}
          helperText={errors && errors.longitude ? 'O campo é inválido' : ''}
          name="longitude"
          label="Longitude"
          value={values.longitude}
          onChange={handleChange}
          disabled={!isAdmin}
          format="##,######"
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          label="Km"
          name="km"
          onChange={handleChange}
          value={values.km}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          label="Km Urbano"
          name="kmRdu"
          onChange={handleChange}
          value={values.kmRdu}
          disabled={!isAdmin && !usuarioCroquiPodeEditar}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          label="Km Rural"
          name="kmRdr"
          onChange={handleChange}
          value={values.kmRdr}
          disabled={!isAdmin && !usuarioCroquiPodeEditar}
        />
      </Grid>
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          label="Km Inspecionado"
          name="kmInspecao"
          onChange={handleChange}
          value={values.kmInspecao}
          disabled={!isAdmin && !usuarioCroquiPodeEditar}
        />
      </Grid>
      {isInspecaoMtBt(values.tipoServicoId) && <>
        <Grid item xs={6} sm={2} className={classes.fieldContainer}>
          <InputFormat
            label="Quantidade de Postes"
            name="qtdPostes"
            onChange={handleChange}
            value={values.qtdPostes || ''}
            disabled={!isAdmin}
            format="######"
            error={errors && errors.qtdPostes ? true : false}
          />
        </Grid>
      </>}
      <Grid item xs={6} sm={2} className={classes.fieldContainer}>
        <Input
          label="Situação"
          name="situacao"
          onChange={handleChange}
          value={values.situacao}
          disabled={!isAdmin}
        />
      </Grid>
      <Grid item xs={12} sm={isInspecaoMtBt(values.tipoServicoId) ? 2 : 6} className={classes.fieldContainer}>
        <Input
          label="Cidade"
          name="cidade"
          onChange={handleChange}
          value={values.cidade}
          disabled={!isAdmin}
        />
      </Grid>
      {values.id && isInspecaoMtBt(values.tipoServicoId) && (
        <Grid item md={2} xs={6} className={classes.fieldContainer}>
          <TrueFalseSelect
            label="Auditoria"
            name="auditoria"
            disabled={!podeEditarAuditoria}
            showEmpty
            error={errors && errors.auditoria ? true : false}
            onChange={event => {
              const raw = event.target.value;
              const auditoriaBool = raw === 'true' ? true : raw === 'false' ? false : null;
              setValues({ ...values, auditoria: auditoriaBool });
            }}
            value={values.auditoria === true ? 'true' : values.auditoria === false ? 'false' : ''}
          />
        </Grid>
      )}
    </>
  );
};

InformacaoBasicaForm.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  isAdmin: PropTypes.bool,
  usuarioCroquiPodeEditar: PropTypes.bool,
  podeEditarAuditoria: PropTypes.bool,
  patchNsirAuditoria: PropTypes.func.isRequired
};

InformacaoBasicaForm.defaultProps = {
  errors: null,
  isAdmin: false,
  usuarioCroquiPodeEditar: false,
  podeEditarAuditoria: false
};

export default InformacaoBasicaForm;
